import React, { useState, useEffect } from "react";
import  AOS  from "aos";
import "aos/dist/aos.css";

const Article = ({
  type,
  name,
  glass,
  img,
  category,
  Ingredients,
  Instructions,
  setIsClicked,
}) => {

  //   This useEffect for animation on Scroll
  useEffect(() => {
    //   'duration' for animation load time, and 'once' for how many time I want to show the animation, here I just want to show the animation only window onload, so I give it true.
    AOS.init({ duration: 1500, once: true });
  }, []);

  return (
    <article className="single-article">
      <img
        data-aos="fade-right"
        onClick={() => setIsClicked(true)}
        src={img || "default img"}
        alt={name || "default img"}
        className="single-img mx-auto"
      />
      <div data-aos="fade-left" className="article-text  px-6 md:px-0  md:ml-[5px!important]">
        <h1 className="single-title-heading-description sm:w-[100%!important] mx-auto text-center uppercase tracking-[0.3rem!important] bg-[rgba(253,1,1,0.5)!important] mb-[8px!important]">Details</h1>
        <div>
          <h3 className=" single-title-heading-description">Name:</h3>
          <p className="description-p">{name || "Name missing"}</p>
        </div>
        <div>
          <h3 className=" single-title-heading-description">Type:</h3>
          <p className="description-p">{type || "Unknown type"}</p>
        </div>
        <div>
          <h3 className=" single-title-heading-description">Glass:</h3>
          <p className="description-p">{glass || "Long glass"}</p>
        </div>
        <div>
          <h3 className=" single-title-heading-description">Category:</h3>
          <p className="description-p">{category || "Category not fact"}</p>
        </div>
        <div >
          <h3 className=" single-title-heading-description">Instructions:</h3>
          <p className="description-p">{Instructions || "Something, I don't know!"}</p>
        </div>
        <div>
          <h3 className=" single-title-heading-description">Ingredients:</h3>
          <p className="description-p">
            {Ingredients &&
              Ingredients.map((item, index) => {
                return item ? (
                  <span key={index} className="ingredients">
                    {item}
                  </span>
                ) : null;
              })}
            .
          </p>
        </div>
      </div>
    </article>
  );
};

export default Article;
